/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';

const MaintenanceViewHeaderContents = () => {
  const count = 0;

  return (
    <React.Fragment>
      <h1>
        Maintenance
        <span className="viewheader__count"> ({count})</span>
      </h1>
    </React.Fragment>
  );
};

export default MaintenanceViewHeaderContents;
